import MediaQuery from 'react-responsive';
import React from 'react';
import PropTypes from 'prop-types'

const breakpoints = {
  pc:577,
  sp:576
}

export default function Breakpoint(props){
  const breakpoint = breakpoints[props.name] || breakpoints.pc;
  switch(props.name){
    case 'pc':
      return (
        <MediaQuery {...props} minDeviceWidth={breakpoint}>
          {props.children}
        </MediaQuery>
      )
    case 'sp':
      return (
        <MediaQuery {...props} maxDeviceWidth={breakpoint}>
          {props.children}
        </MediaQuery>
      )
    default:
    break;
  }
  
}

React.propTypes = {
  name: PropTypes.string,
  children: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/component/Responsive/Breakpoint.jsx